import React, { FC } from 'react';
import { Alert, Space, Switch } from 'antd';
import { TextBlock, TextSpan } from '../../../uicomp/atmos/content-block/ContentBlock';
import { useSearchContext } from '../SearchContext';

export const NoJobAlert: FC = () => {
  const ctx = useSearchContext();
  return (
    <>
      {(ctx.results?.total ?? 0) === 0 && (
        <Space className={'fullwidth'} direction={'vertical'} style={{ padding: 20 }}>
          <Space className="fullwidth" direction="vertical">
            <Space size={'large'} style={{ height: 30 }}>
              <TextBlock strong>Turn on job alerts</TextBlock>
              <Switch
                disabled={!ctx.alertEnable}
                checked={!!ctx.results?.alertId}
                onChange={(checked) => ctx.setAlert(checked)}
              />
            </Space>
          </Space>
          <Space align={'center'} className={'fullwidth'} style={{ justifyContent: 'center' }}>
            <Alert
              style={{ marginTop: 20 }}
              message="No jobs found"
              description={
                <Space direction="vertical">
                  <TextSpan>
                    Your search{' '}
                    {(ctx.query.search ?? '').trim() === '' ? (
                      ''
                    ) : (
                      <>
                        {'for '}
                        <strong>{`${ctx.query.search} `}</strong>
                      </>
                    )}
                    {"didn't match any jobs"}
                  </TextSpan>
                  <div>
                    <TextBlock heading level={-3}>
                      Search tips
                    </TextBlock>
                    <ul>
                      <li>Check the spelling of search terms</li>
                      <li>Try alternative terms</li>
                      <li>Adjust the filters to broaden your search</li>
                    </ul>
                  </div>
                </Space>
              }
              type="warning"
              showIcon
            />
          </Space>
        </Space>
      )}
    </>
  );
};
